import { ClipboardList, ShieldCheck, ShieldOff } from "lucide-react";

import { formatIban } from "@/utils/iban";
import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import ExemptionDocumentViewer from "@/components/exemption-document-viewer";
import { formatTRY } from "@/utils/currency";

const formatDate = (value) => {
  if (!value) return "-";
  const d = new Date(value);
  return Number.isNaN(d.getTime())
    ? String(value)
    : d.toLocaleString("tr-TR", { dateStyle: "medium", timeStyle: "short" });
};

function Row({ label, value, mono }) {
  return (
    <div className="flex flex-col gap-0.5 border-b py-2 last:border-b-0 sm:flex-row sm:items-center sm:justify-between sm:gap-4">
      <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
        {label}
      </span>
      <span
        className={`text-sm text-foreground ${mono ? "font-mono" : ""} break-all sm:text-right`}
      >
        {value || "-"}
      </span>
    </div>
  );
}

/**
 * istisna / gider pusulasi akisinda influencer fatura yuklemez; odeme bilgileri
 * formunu doldurur. Bu bilesen fatura PDF'inin yerine o formdaki verileri
 * gosterir. Istisna belgesi yuklendiyse altinda belgeyi de gosterir.
 */
export default function FormSubmissionSummary({ commissionDetail, documentHeight = "600px" }) {
  if (!commissionDetail) return null;

  const isExempt = Boolean(commissionDetail.isExemptAccount);

  return (
    <div className="flex flex-col gap-4">
      <Card>
        <CardHeader className="pb-3">
          <div className="flex items-start justify-between gap-3">
            <div>
              <CardTitle className="flex items-center gap-2 text-base">
                <ClipboardList className="h-4 w-4" />
                Ödeme Bilgileri Formu
              </CardTitle>
              <CardDescription>
                Bu kayıt fatura yüklenmeden, influencer'ın doldurduğu formla oluşturuldu.
              </CardDescription>
            </div>
            <Badge
              variant={isExempt ? "default" : "secondary"}
              className="flex shrink-0 items-center gap-1"
            >
              {isExempt ? (
                <ShieldCheck className="h-3 w-3" />
              ) : (
                <ShieldOff className="h-3 w-3" />
              )}
              {isExempt ? "İstisna hesabı" : "Gider pusulası"}
            </Badge>
          </div>
        </CardHeader>
        <CardContent>
          <Row label="Ad Soyad" value={commissionDetail.recipientName} />
          <Row label="TC Kimlik / Vergi No" value={commissionDetail.taxNumber} mono />
          <Row label="IBAN" value={formatIban(commissionDetail.iban || "")} mono />
          <Row label="Hesap Sahibi" value={commissionDetail.bankAccountHolder} />
          <Row label="E-posta" value={commissionDetail.email} />
          <Row
            label="İl / Ülke"
            value={[commissionDetail.recipientCity, commissionDetail.recipientCountry]
              .filter(Boolean)
              .join(" / ")}
          />
          <Row
            label="Tutar"
            value={formatTRY(commissionDetail.totalAmount)}
          />
          <Row
            label="İstisna Belgesi"
            value={
              commissionDetail.exemptionDocPath
                ? "Yüklendi (aşağıda)"
                : isExempt
                ? "Yüklenmedi"
                : "Gerekli değil"
            }
          />
          <Row label="Gönderim Tarihi" value={formatDate(commissionDetail.createdAt)} />
        </CardContent>
      </Card>

      {commissionDetail.exemptionDocPath && (
        <ExemptionDocumentViewer
          commissionDetailId={commissionDetail.id}
          height={documentHeight}
        />
      )}
    </div>
  );
}
